<template>
  <v-dialog
    persistent
    :modelValue="modelValue"
    width="640"
    contentClass="create-placement-dialog"
    overlayOpacity="0.85"
    @update:modelValue="(...v) => $emit('update:modelValue', ...v)"
  >
    <v-card flat>
      <v-card-title class="headline">Create new placement zone</v-card-title>
      <v-card-text>
        <RfZoneId
          ref="zoneDetails"
          :key="resetKey"
          :model="createModel"
          showFullModal
          :lockTypeFields="!!(promptType || deviceType)"
        />
      </v-card-text>
      <v-card-actions class="modal-card-actions-div">
        <v-btn size="large" class="cancel-btn" variant="outlined" width="100px" @click="closeDialog"
          >Close</v-btn
        >
        <v-btn
          size="large"
          width="260px"
          color="success"
          :disabled="!isZoneIsValid"
          variant="flat"
          @click="createNewPathGroup"
        >
          <v-icon size="small" start>md:save</v-icon>Create new placement
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RfZoneId from "@/components/RfCommonCards/RfZoneId.vue";
import {
  DEFAULT_PROMO_DIMENSIONS,
  getDefaultPromoRatio,
  defaultPromoType,
} from "@/utils/PromoDimUtils";
import { cloneDeep } from "lodash-es";
import { useToastsStore } from "@/pinia/toastsStore";
import { ref } from "vue";
import { useLegacyTmpStore } from "@/pinia/legacyTmpStore";
import { usePromptStore } from "@/pinia/promptStore";

export default {
  name: "RfCreateNewPlacement",
  components: { RfZoneId },
  props: ["modelValue", "promptType", "deviceType"],
  setup: () => ({
    toastsStore: useToastsStore(),
    zoneDetails: ref(),
    promptStore: usePromptStore(),
    legacyTmpStore: useLegacyTmpStore(),
  }),
  data() {
    return {
      createModel: this.getDefaultModel(),
      resetKey: 0,
    };
  },
  computed: {
    isZoneIsValid() {
      return this.zoneDetails?.isValid;
    },
  },
  watch: {
    modelValue(val) {
      if (val) {
        this.createModel = this.getDefaultModel();
        this.resetKey++;
      }
    },
  },
  methods: {
    closeDialog() {
      this.resetKey++;
      this.$emit("update:modelValue", false);
    },
    async createNewPathGroup() {
      try {
        const { deviceType, placementType: pathType, fillModel } = this.zoneDetails;
        this.$emit("update:modelValue", false);

        await this.legacyTmpStore.getPathGroupModel({
          appId: this.$route.params.aid,
          pathType,
          deviceType,
        });
        const model = cloneDeep(this.legacyTmpStore.pathGroup);
        fillModel(model);
        await this.promptStore.createPathGroup({ appId: this.$route.params.aid, model });
        this.toastsStore.create({ type: "success", body: "Zone created successfully" });
        this.createModel = this.getDefaultModel();
        this.resetKey++;
      } catch (e) {
        this.toastsStore.create({ type: "error", body: e.message });
      }
    },
    getDefaultModel() {
      return {
        name: null,
        description: null,
        zone: null,
        path_type: this.promptType || "horizontal",
        device_type: this.deviceType || "web",
        displayType: "stack",
        settings: {
          ...DEFAULT_PROMO_DIMENSIONS[defaultPromoType][getDefaultPromoRatio(defaultPromoType)],
        },
        zone_type: "live",
        paths: [],
      };
    },
  },
};
</script>
